<template>
  <div class="card purple">
    <div class="content">
      <div class="header">
        {{ $t('LIFECYCLE') }}
        <i class="right floated history icon"></i>
      </div>
      <div class="meta" v-html="$t('LIFECYCLE_META', { event: trigger && trigger.event })"></div>
    </div>
    <div class="primary content">
      <!-- Global events -->
      <div class="grouped fields">
        <label for="event">{{ $tc('GLOBAL_LIFECYCLE_EVENT', 1) }}</label>
        <div class="field" v-for="(item, index) of globalEvents" :key="index">
          <div class="ui radio checkbox" :for="'event' + index">
            <input
              type="radio"
              name="event"
              :id="'event' + index"
              v-model="trigger.event"
              :value="item.id"
            />
            <label>{{ $t('LIFECYCLE_TRIGGER_' + item.name) }}</label>
          </div>
        </div>
      </div>
      <!-- App local events -->
      <div class="grouped fields">
        <label for="event">{{ $tc('APP_LIFECYCLE_EVENT', 1) }}</label>
        <div class="field" v-for="(item, index) of appEvents" :key="index">
          <div class="ui radio checkbox" :for="'event' + index">
            <input
              type="radio"
              name="event"
              :id="'event' + index"
              v-model="trigger.event"
              :value="item.id"
            />
            <label>{{ $t('LIFECYCLE_TRIGGER_' + item.name) }}</label>
          </div>
        </div>
      </div>
      <!-- Url for NAVIGATED --->
      <regex-field
        v-if="trigger.event === 'NAVIGATED'"
        v-model="trigger.fromUrl"
        :labelText="$t('FROM', { thing: $t('URL') })"
        :placeholder="$t('FROM', { thing: $t('URL') })"
      />
      <regex-field
        v-if="trigger.event === 'NAVIGATED'"
        v-model="trigger.toUrl"
        :labelText="$t('TO', { thing: $t('URL') })"
        :placeholder="$t('TO', { thing: $t('URL') })"
      />
      <!-- Which app is this trigger for -->
      <div class="field" v-if="isAppEvent">
        <typeahead
          :multiple="false"
          :current-item="currentApp"
          :items="appsForEvent"
          :label-text="$tc('APPLICATION', 1)"
          :placeholder-text="$t('CURRENT_APPLICATION')"
          :empty-text="$t('CURRENT_APPLICATION')"
          :select-handler="applicationSelected"
          :remove-handler="applicationSelected"
          :disabled="isEditDisabled"
        >
          <template slot="selected" slot-scope="props">
            <span class="text">{{ props.item.name }}</span>
          </template>
          <template slot="dropdown" slot-scope="props">
            <span class="text">
              <i class="icon" :class="props.item.icon" :style="{ color: props.item.color }" />
              {{ props.item.name }}</span
            >
          </template>
        </typeahead>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
// @flow
import _ from 'lodash'
import { Application, Validation } from 'services'
import { Typeahead, RegexField } from 'ui'

export default {
  name: 'lifecycletrigger',
  components: { Typeahead, RegexField },
  props: {
    trigger: {
      type: Object,
      default: () => {
        return {
          event: '',
          toUrl: '',
          fromUrl: '',
          appId: ''
        }
      }
    }
  },

  computed: {
    isEditDisabled() {
      return this.$store.state.flowEditor.isFlowEditingDisabled
    },
    isAppEvent() {
      var e = _.find(this.possibleEvents, evt => evt.id === this.trigger.event)
      return e && e.scope === 'app'
    },
    globalEvents() {
      return _.filter(this.possibleEvents, e => e.scope === 'global')
    },
    appEvents() {
      return _.filter(this.possibleEvents, e => e.scope === 'app')
    },
    currentApp() {
      var selected = _.find(this.apps, app => app.id === this.trigger.appId)
      return (selected && selected.name) || this.trigger.appId
    },
    appsForEvent() {
      return _.map(this.apps, app => ({
        ...app,
        icon: this.appTypes[app.type] && this.appTypes[app.type].icon,
        color: (this.appTypes[app.type] && this.appTypes[app.type].color) || '#000'
      }))
    },
    apps() {
      if (this.trigger.event === 'NAVIGATED') {
        return _.filter(
          this.$store.state.application.items,
          app => !Validation.isUrlContainsDisabled(app)
        )
      }
      return this.$store.state.application.items
    }
  },

  methods: {
    applicationSelected(app) {
      this.trigger.appId = app && app.id
    }
  },

  data() {
    return {
      appTypes: {},
      selectedApp: '',
      possibleEvents: [
        {
          id: 'ATTACHED',
          name: 'ATTACHED',
          scope: 'app'
        },
        {
          id: 'DETACHED',
          name: 'DETACHED',
          scope: 'app'
        },
        {
          id: 'MANATEESTARTED',
          name: 'MANATEESTARTED',
          scope: 'global'
        },
        {
          id: 'NAVIGATED',
          name: 'NAVIGATED',
          scope: 'app'
        }
      ]
    }
  },

  watch: {
    'trigger.event': function(e) {
      if (
        e === 'MANATEESTARTED' ||
        (e === 'NAVIGATED' && Validation.isUrlContainsDisabled(this.currentApp))
      ) {
        this.trigger.appId = ''
      }
    }
  },

  mounted() {
    Application.getAllApplicationTypes().then(types => {
      this.appTypes = _.keyBy(types, 'type')
    })
  }
}
</script>
